/**
 * Internals
 */
const permissionIdentities = require('./permission-identities');
const requestSchemas = require('./request-schemas');
const routes = require('./routes');
const scopes = require('./scopes');

module.exports = {
  permissionIdentities,
  requestSchemas,
  routes,
  scopes,
};
